/**
 * Checks if a discount code is in the correct format for a BA code.
 * BA codes are in the format E-NAME50.
 *
 * @returns the capitalised and trimmed discount code if it is in the correct format, null otherwise.
 */
export const normaliseBaCodeFormat = (
  discountCode?: string | null,
): string | null => {
  const formattedDiscountCode = discountCode?.toUpperCase().trim();

  const isValid = !!formattedDiscountCode && (
    formattedDiscountCode.startsWith("E-") &&
    formattedDiscountCode.endsWith("50")
  );

  return isValid ? formattedDiscountCode : null;
};